export function formatCnpj(input: string): string {
  input = input.replace(/\D/g, "");

  const length = input.length;

  if (length < 3) return input;
  if (length < 6) return input.substr(0, 2) + "." + input.substr(2, 3);
  if (length < 9)
    return (
      input.substr(0, 2) + "." + input.substr(2, 3) + "." + input.substr(5, 3)
    );
  if (length < 13)
    return (
      input.substr(0, 2) +
      "." +
      input.substr(2, 3) +
      "." +
      input.substr(5, 3) +
      "/" +
      input.substr(8, 4)
    );

  return (
    input.substr(0, 2) +
    "." +
    input.substr(2, 3) +
    "." +
    input.substr(5, 3) +
    "/" +
    input.substr(8, 4) +
    "-" +
    input.substr(12, 2)
  );
};